import { Button, Dropdown, Table } from "antd";
import { MoreHorizontal, Sparkles, Trash2 } from "lucide-react";
import React, { useState } from "react";
import DeleteReportModal from "../optimizeResume/modals/DeleteReportModal";
import { useNavigate } from "react-router-dom";

function ReportTable({
  setSelectedUserIds,
  selectedUserIds,
  deleteReportApi,
  reports,
}) {
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [reportToDelete, setReportToDelete] = useState(null);
  const rowSelection = {
    selectedRowKeys: selectedUserIds,

    onChange: (selectedRowKeys) => {
      setSelectedUserIds(selectedRowKeys);
    },
  };

  const actionItems = [
    // {
    //   key: "view",
    //   label: (
    //     <span className="text-gray-700 font-medium py-1 text-[.8rem] flex gap-[8px] items-center">
    //       {" "}
    //       <Sparkles size={15} />
    //       View report
    //     </span>
    //   ),
    // },
    {
      key: "delete",
      label: (
        <span className="text-gray-700 font-medium py-1 text-[.8rem] flex gap-[8px] items-center">
          {" "}
          <Trash2 size={15} />
          Delete report
        </span>
      ),
    },
  ];

  const columns = [
    {
      title: (
        <span className="text-[#475467] font-medium text-[.8rem]">
          File Name
        </span>
      ),
      dataIndex: "fileName",
      key: "name",
      // width: 400, // Increased width for Name column
      render: (_, record) => (
        <div>
          <p className="font-semibold text-gray-800 mb-0 text-[.8rem] break-all">
            {record?.resumeFileName}
          </p>
          <p className="text-[.75rem] text-[#475467] font-normal">
            {record?.resumeIdentifier || "N/A"}
          </p>
        </div>
      ),
    },
    {
      title: (
        <span className="text-[#475467] font-medium text-[.8rem]">
          Job Name
        </span>
      ),
      dataIndex: "jobName",
      key: "job",
      align: "center",
      // width: 400, // Increased width for Name column
      render: (_, record) => (
        <div>
          <p className="font-semibold text-gray-800 mb-0 text-[.8rem] break-all">
            {record?.jobTitle}
          </p>
          <p className="text-[.75rem] text-[#475467] font-normal">
            {record?.jdIdentifier || "N/A"}
          </p>
        </div>
      ),
    },
    {
      title: (
        <span className="text-[#475467] font-medium text-[.8rem]">
          Created On
        </span>
      ),
      key: "created",
      align: "center",
      render: (record) => (
        <span className="text-[#475467] font-normal text-[.8rem]">
          {new Date(record?.creationTime).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </span>
      ),
    },
    {
      title: (
        <div className="text-center text-[#475467] font-medium text-[.8rem]">
          View report
        </div>
      ),
      align: "center",
      render: (record) => (
        <span className="text-[#475467] font-normal text-[.8rem] flex justify-center">
          <button
            onClick={() => {
              navigate(
                `/viewReport?matchAnalysisIdentifier=${record?.matchAnalysisIdentifier}&resumeIdentifier=${record?.resumeIdentifier}`,
              );
            }}
            className="btn-orange text-gray-400 flex gap-1 items-center px-2 py-1"
          >
            View
          </button>
        </span>
      ),
    },
    {
      title: (
        <div className="text-center text-[#475467] font-medium text-[.8rem]">
          Actions
        </div>
      ),
      key: "action",
      align: "center",
      // width: 40,
      render: (_, record) => (
        <span className="flex items-center gap-2 justify-center">
          <Dropdown
            menu={{
              items: actionItems,
              onClick: ({ key }) => {
                if (key === "delete") {
                  setReportToDelete(record);
                  setDeleteModal(true);
                }
                if (key === "view") {
                  //   handleRedirectEdit(record?.resumeIdentifier);
                }
              },
            }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Button
              type="text"
              icon={<MoreHorizontal size={16} />}
              className="!text-gray-500 !p-0 !w-6 !h-6"
            />
          </Dropdown>
        </span>
      ),
    },
  ];
  return (
    <div className="rounded-2xl bg-white shadow-sm">
      <Table
        columns={columns}
        dataSource={reports}
        rowKey="reportIdentifier"
        pagination={false}
        // rowSelection={{
        //   type: "checkbox",
        //   ...rowSelection,
        // }}
        scroll={{ x: 1100 }}
      />

      {deleteModal && (
        <DeleteReportModal
          deleteModal={deleteModal}
          setDeleteModal={setDeleteModal}
          report={reportToDelete}
          deleteReportApi={deleteReportApi}
        />
      )}
    </div>
  );
}

export default ReportTable;
